import BaseAPIService from '@/services/baseAPIService'

export default class AdminAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Account
  getAccount() { return this.httpClient.get(`/account`) }
  updateAccount(data)   { return this.httpClient.put(`/account`, data) }

  // Account - Setup
  activateAccount(data)             { return this.httpClient.post('/account/activate', data) }

  // Account - Billing
  getAccountBilling()               { return this.httpClient.get(`/account/billing`) }
  updateAccountBilling(data = {})   { return this.httpClient.put(`/account/billing`, data) }
  createBillingCheckoutSession(data = {})    { return this.httpClient.post(`/addons/billing/session/checkout`, data) }
  createBillingPortalSession(data = {})      { return this.httpClient.post(`/addons/billing/session/portal`, data) }

  // Account - Billing Products
  getBillingProducts()              { return this.httpClient.get(`/addons/billing/products`) }

  getAccountLocations()             { return this.cachedGet(`/account/locations`) }
  createAccountLocation(data)       { return this.httpClient.post(`/account/locations`, data) }
  updateAccountLocation(id, data)   { return this.httpClient.put(`/account/locations/${id}`, data) }
  deleteAccountLocation(id)   { return this.httpClient.delete(`/account/locations/${id}`) }

  getAccountSettings()                { return this.httpClient.get(`/account/settings`) }
  getAccountSettingForKey(settingKey, defaultValue = '') {
    return new Promise((resolve, reject) => {
      return this.httpClient.get(`/account/settings`)
      .then(response => {
        if(response.data[settingKey] !== undefined)
          return resolve(response.data[settingKey])
        return resolve(defaultValue)
      })
      .catch(err => {
        return reject(err)
      })
    })
  }
  updateAccountSettings(data)         { return this.httpClient.put(`/account/settings`, data) }
  resetAccountSettings()              { return this.httpClient.post(`/account/settings/reset`) }

  // Integrations
  getIntegrationList() { return this.httpClient.get(`/integrations`) }

  // Tools - Import/Export
  importDataFile(data)  { return this.httpClient.post(`/admin/import`, data) }

  // Tools - Opening Balance
  updateOpeningBalanceGlass(data)   { return this.httpClient.put(`/admin/tools/openingbalance/glass`, data) }

  // Tools - Manual Usage Data
  getManualUsageInfo()                { return this.httpClient.get(`/admin/tools/manualusage/info`) }
  getManualUsageGlassSizes(params)    { return this.httpClient.get(`/admin/tools/manualusage/glasssizes?${$.param(params)}`) }
  updateManualUsageGlassSizes(data)   { return this.httpClient.put(`/admin/tools/manualusage/glasssizes`, data) }

  // Currency
  getCurrencyList()         { return this.httpClient.get(`/currency`) }
  createCurrency(data)      { return this.httpClient.post(`/currency`, data) }
  updateCurrency(id, data)  { return this.httpClient.put(`/currency/${id}`, data) }
  deleteCurrency(id)        { return this.httpClient.delete(`/currency/${id}`) }

  // Tax Rates
  getTaxRateList()         { return this.httpClient.get(`/taxrates`) }
  createTaxRate(data)      { return this.httpClient.post(`/taxrates`, data) }
  updateTaxRate(id, data)  { return this.httpClient.put(`/taxrates/${id}`, data) }
  deleteTaxRate(id)        { return this.httpClient.delete(`/taxrates/${id}`) }

  // Message Templates
  getMessageTemplateList()         { return this.httpClient.get(`/communication/messagetemplates`) }
  createMessageTemplate(data)      { return this.httpClient.post(`/communication/messagetemplates`, data) }
  updateMessageTemplate(id, data)  { return this.httpClient.put(`/communication/messagetemplates/${id}`, data) }
  deleteMessageTemplate(id)        { return this.httpClient.delete(`/communication/messagetemplates/${id}`) }

  getMessageTemplatePlaceholderList(templateType = null) {
    var filter = templateType ? `filter[type]=${templateType}` : ''
    return this.httpClient.get(`/communication/messagetemplateplaceholders?${filter}`)
  }


  // Descriptor Lookups
  getDescriptorLookupList()         { return this.httpClient.get(`/descriptorlookup`) }
  getDescriptorLookupListForType(type)   { return this.httpClient.get(`/descriptorlookup/${type}`) }
  createDescriptorLookup(data)      { return this.httpClient.post(`/descriptorlookup`, data) }
  updateDescriptorLookup(id, data)  { return this.httpClient.put(`/descriptorlookup/${id}`, data) }
  deleteDescriptorLookup(id)        { return this.httpClient.delete(`/descriptorlookup/${id}`) }

  // Sequence Configs
  getSequenceConfigList()   { return this.httpClient.get(`/sequenceconfig`) }
  updateSequenceConfig(code, data)   { return this.httpClient.put(`/sequenceconfig/${code}`, data) }

  // Report config
  getReportConfig()                 { return this.httpClient.get(`/reportconfig`) }
  updateReportConfig(data)          { return this.httpClient.put(`/reportconfig`, data) }

  // Kiosk config
  getKioskConfig()                  { return this.httpClient.get(`/kioskconfig`) }
  updateKioskConfig(data)           { return this.httpClient.put(`/kioskconfig`, data) }

  // Print label config
  getPrintLabelConfigList()         { return this.httpClient.get(`/printlabelconfigs`) }
  getPrintLabelConfig(id)           { return this.httpClient.get(`/printlabelconfigs/${id}`) }
  createPrintLabelConfig(data)      { return this.httpClient.post(`/printlabelconfigs`, data) }
  updatePrintLabelConfig(id, data)  { return this.httpClient.put(`/printlabelconfigs/${id}`, data) }

  // Calendar Config
  getAvailabilityShiftList()        { return this.httpClient.get(`/availabilityshifts`) }
  updateAvailabilityShiftList(data) { return this.httpClient.put(`/availabilityshifts`, data) }

  getCalendarConfigSetting()        { return this.httpClient.get(`/calendar/configuration/settings`) }
  updateCalendarConfigSettings(data)  { return this.httpClient.put(`/calendar/configuration/settings`, data) }

  // Calendar Events
  getCalendarEventList()            { return this.httpClient.get(`/calendarevents`) }
  createCalendarEvent(data)         { return this.httpClient.post(`/calendarevents`, data) }
  updateCalendarEvent(id, data)     { return this.httpClient.put(`/calendarevents/${id}`, data) }
  deleteCalendarEvent(id)           { return this.httpClient.delete(`/calendarevents/${id}`) }

  getCalendarUpcomingPublicHolidays() { return this.httpClient.get(`/publicholidays/upcoming`) }


}
